import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './ExhibitorPasscodes.module.css'
import { saveAs } from 'file-saver';
// ------ Components ------ //
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import PasscodeItem from '../../../components/LeadCapture/ExhibitorPasscodes/PasscodeItem'
// ------ Services ------ //
import * as webBridgeService from '../../../services/webBridgeService'
import * as exhibitorLeadCaptureService from '../../../services/exhibitorLeadCaptureService'
// ------ Font Awesome assets ------ //
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareCaretUp, faSquareCaretDown } from '@fortawesome/free-solid-svg-icons'
// ------ Image Elements ------ //
const up = <FontAwesomeIcon icon={faSquareCaretUp} style={{ color: 'blue', width: '20px', height: '20px' }} />
const down = <FontAwesomeIcon icon={faSquareCaretDown} style={{ color: 'blue', width: '20px', height: '20px' }} />

const ExhibitorPasscodes = ({ user }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const stateData = location.state
    var exhibitorAccount = stateData['exhibitorAccount']
    var passedUser = stateData['user']    // not sure if needed, should match ({ user }) already, bu tmight be needed for impersonation or selection
    const [limitedExhibitors, setLimitedExhibitors] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [message, setMessage] = useState("");
    const [messageColor, setMessageColor] = useState('green');
    const [passcodes, setPasscodes] = useState([]);
    const [passcodesFile, setPasscodesFile] = useState([]);
    const [processing, setProcessing] = useState(false)
    const [combinedFilteredPasscodes, setCombinedFilteredPasscodes] = useState([]);
    const [email, setEmail] = useState(null);
    const [pdfName, setPdfName] = useState(null);
    const [sorting, setSorting] = useState({ key: "lastName", ascending: true });
    const [exhibitorLeadCaptureInfo, setExhibitorLeadCaptureInfo] = useState({});
    const exhibitorLeadCaptureInfoRef = useRef(null);
    if (exhibitorLeadCaptureInfoRef === null || exhibitorLeadCaptureInfoRef.current === null) {
        if (!exhibitorAccount || !exhibitorAccount.clientName) {
            exhibitorLeadCaptureInfoRef.current = exhibitorLeadCaptureService.getExhibitorLeadCapture();
        }
        else {
            let passedData = {
                clientId: exhibitorAccount.clientId,
                clientName: exhibitorAccount.clientName,
                leadCaptureId: exhibitorAccount.leadCaptureId,
                leadCaptureName: exhibitorAccount.leadCaptureName,
                exhibitorId: exhibitorAccount.exhibitorId,
            }
            exhibitorLeadCaptureInfoRef.current = passedData
        }
    }
	function applySorting(key) {
        if (sorting.key === key) {
            setSorting({ ...sorting, ascending: !sorting.ascending });
        } else {
            setSorting({ key: key, ascending: true });
        }
    }
	
    useEffect(() => {
        const interval = setInterval(() => checkExhibitorLeadCapture(), (300)) // run events fetch every .3 seconds
        return () => clearInterval(interval)
    }, [])
    const checkExhibitorLeadCapture = () => {
        // Update clientevent with every render when its value has changed.
        let savedExhibitorLeadCapture = exhibitorLeadCaptureService.getExhibitorLeadCapture();
        if (exhibitorLeadCaptureInfoRef.current && exhibitorLeadCaptureInfoRef.current.leadCaptureId !== undefined &&
            savedExhibitorLeadCapture && savedExhibitorLeadCapture.leadCaptureId !== undefined && savedExhibitorLeadCapture.exhibitorId !== undefined &&
            (savedExhibitorLeadCapture.leadCaptureId !== exhibitorLeadCaptureInfoRef.current.leadCaptureId ||
                savedExhibitorLeadCapture.exhibitorId !== exhibitorLeadCaptureInfoRef.current.exhibitorId)) {
            setExhibitorLeadCaptureInfo(savedExhibitorLeadCapture)
            exhibitorLeadCaptureInfoRef.current = savedExhibitorLeadCapture;
        }
    }
	
    const isEmailInvalid = () => {
        if (!email) return false; // empty field is valid for local download
        const validEmailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        const emailParts = email.split('@');

        if (emailParts.length !== 2) return true;
        const account = emailParts[0];
        const domain = emailParts[1];

        if (account.length > 64) return true;
        else if (domain.length > 255) return true;

        const domainParts = domain.split('.');

        if (domainParts.some((part) => part.length > 63)) return true;

        return !(validEmailRegex.test(email));
    }
    const handleChange = e => {
        setEmail(e.target.value);
    }
    const createRequestBodyEmail = async () => {

        let requestBody = {}
        if (pdfName) {
            requestBody =
            {
                "email": `${email}`,
                "pdfName": `${pdfName}`,
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
        else {
            requestBody =
            {
                "email": `${email}`,
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
        return await requestBody;
    }
    const createRequestBody = async () => {

        let requestBody = {}
        if (pdfName) {
            requestBody =
            {
                "pdfName": `${pdfName}`,
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
        else {
            requestBody =
            {
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
        return await requestBody;
    }
    const generatePasscodeEmail = async () => {
        const getReqBody = await createRequestBodyEmail()
        try {
            await webBridgeService.emailExhibitorPasscodes(getReqBody)
            setMessage('Email sent!')
            setMessageColor('green')
        } catch (err) {
            setMessage('Error: ' + err.message);
            setMessageColor('red')
        }
    }
    const generatePasscodesFile = async () => {
        const getReqBody = await createRequestBody()
        try {
            setMessage('Downloading...')
            setMessageColor('green')
            let passcodesFile = await webBridgeService.generateExhibitorPasscodes(getReqBody)
            if (passcodesFile) {
                setPasscodesFile(passcodesFile);
                setMessage('Download Complete!')
                setMessageColor('green')
            }
            return passcodesFile;

        } catch (err) {
            setMessage('Error: ' + err.message);
            setMessageColor('red')
        }
    }
    function base64ToBlob(base64Data, contentType = 'application/pdf') {
        let byteCharacters = '';
        if (base64Data.split(',').length > 1) {
            byteCharacters = atob(base64Data.split(',')[1]);
        }
        else {
            byteCharacters = atob(base64Data);
        }
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    const handleJSDownload = async (e) => {
        e.preventDefault();

        if (!limitedExhibitors) {
            return;
        }
        setProcessing(true)
        if (email && !isEmailInvalid()) {
            setMessage('Sending...')
            setMessageColor('green')
            // send email
            await generatePasscodeEmail();
            setProcessing(false)
            return;
        }
        let holder = null;
        if (passcodesFile || passcodesFile.length < 1) {
            setMessage('Downloading...')
            setMessageColor('green')
            holder = await generatePasscodesFile();
            setProcessing(false)
        }
        if (passcodesFile && passcodesFile.attachment) {
            let buffer = base64ToBlob(passcodesFile.attachmentBase64);
            // Save the Excel file
            saveAs(new Blob([buffer]), `${passcodesFile.fileName}`);
        }
        if (holder && holder.attachment) {
            let buffer = base64ToBlob(holder.attachmentBase64);
            // Save the Excel file
            saveAs(new Blob([buffer]), `${holder.fileName}`);
        }
    };
	useEffect(() => {
        if (passcodes && passcodes.length > 0) {
            let passes = [...passcodes];
            // apply sorting
            let sortedResults = passes.sort((a, b) => {
                const optionA = a[sorting.key] && a[sorting.key] !== undefined ? a[sorting.key].toString().toLowerCase() : ''

                const optionB = b[sorting.key] && b[sorting.key] !== undefined ? b[sorting.key].toString().toLowerCase() : ''

                if (optionA < optionB) {
                    return sorting.ascending ? -1 : 1;
                }
                if (optionA > optionB) {
                    return sorting.ascending ? 1 : -1;
                }
                return 0;
            })
            setCombinedFilteredPasscodes(sortedResults);
        }

    }, [passcodes, sorting])
    const fetchPasscodes = async (ids) => {
        let passcodesList = await webBridgeService.getExhibitorPasscodes(ids);
        if (passcodesList && passcodesList.length > 0) {
            setPasscodes(passcodesList);
        }
    };
    useEffect(() => {
        if (limitedExhibitors) {
            fetchPasscodes(limitedExhibitors);
            setLoaded(true);
        }

    }, [limitedExhibitors])
    useEffect(() => {
        if (exhibitorAccount && exhibitorAccount.id !== undefined) {
            // get invoice, create table of items, seperated by 'limitedexhibitors'
            setPdfName(exhibitorAccount.firstName + '_' + exhibitorAccount.lastName + '_' + exhibitorAccount.organization + '.pdf');
            setLimitedExhibitors(exhibitorAccount.id);
        }
        else if (user && user.limitedExhibitors) {
            // have to parse out the exhibitor accounts
            setLimitedExhibitors(user.limitedExhibitors);
        }
        
    }, [])
    useEffect(() => {
        // get exhibitor
        if ((!exhibitorAccount || !exhibitorAccount.id) && exhibitorLeadCaptureInfo && exhibitorLeadCaptureInfo.exhibitorId) {
            setLimitedExhibitors(exhibitorLeadCaptureInfo.exhibitorId);
        }
    }, [exhibitorLeadCaptureInfo])
    useEffect(() => {
        // check if entry is stored
        // store into local object
        let localExhibitorLeadCapture = exhibitorLeadCaptureService.getExhibitorLeadCapture()
        if (localExhibitorLeadCapture) {
            setExhibitorLeadCaptureInfo(localExhibitorLeadCapture)
        }
        setProcessing(false)
    }, [])

    return (
        <>{!loaded ? <LoadingSpinner /> :
            <>
                <div className={styles.passcodesContainer}>
                    <br /><br />
                    <h1>Passcodes View</h1><br />
                    {exhibitorAccount && exhibitorAccount.id ?
                        <h2>Mobile App passcode(s) for {exhibitorAccount.firstName} {exhibitorAccount.lastName} - {exhibitorAccount.organization} ({exhibitorAccount.refNumber}).</h2>
                        : <></>}
                    <br /><br />
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                    <br /><br /><br />
                    <>

                        <label> <strong>Enter Email address or leave blank to download passcodes locally.</strong> </label>
                        <input
                            type='email'
                            value={email}
                            onChange={handleChange} // option selected
                            name='email'
                            placeholder='Enter Email...'
                        />
                        <br />
                        <button onClick={e => handleJSDownload(e)} disabled={processing} >
                            {email && !isEmailInvalid() ? 'Email Passcodes' : 'Download Passcodes'}
                        </button>
                        {
                            message ?
                                <h2 style={{ color: messageColor }}>{message}</h2> :
                                <></>
                        }
                        <br />
                        <h3>Total Passcodes: {passcodes.length}</h3>
                        <br />
                        <br />
                        {
                            combinedFilteredPasscodes && combinedFilteredPasscodes.length > 0 ?
                                <>
                                    <table className={styles.tablePasscodes}>
                                        <thead>
                                            <tr className={styles.trPasscodes}>
                                                <th className={styles.thPasscodes} onClick={() => applySorting('organization')}>
                                                    Name {sorting.key === 'organization' && sorting.ascending ? up : down}
                                                    <HoverButton
                                                        title={'Exhibitor name'}
                                                        messageWidth={75}
                                                    />
                                                </th>
                                                <th className={styles.thPasscodes} onClick={() => applySorting('passcode')}>
                                                    Passcode {sorting.key === 'passcode' && sorting.ascending ? up : down}
                                                    <HoverButton
                                                        title={'Exhibitor passcode'}
                                                        messageWidth={75}
                                                    />
                                                </th>
                                                <th className={styles.thPasscodes} onClick={() => applySorting('lastName')}>
                                                    Exhibitor Name {sorting.key === 'lastName' && sorting.ascending ? up : down}
                                                    <HoverButton
                                                        title={'Exhibitor contact name'}
                                                        messageWidth={75}
                                                    />
                                                </th>
                                                <th className={styles.thPasscodes} onClick={() => applySorting('email')}>
                                                    Email {sorting.key === 'email' && sorting.ascending ? up : down}
                                                    <HoverButton
                                                        title={'Exhibitor email'}
                                                        messageWidth={75}
                                                    />
                                                </th>
                                                <th className={styles.thPasscodes}>
                                                    Order Date
                                                    <HoverButton
                                                        title={'Exhibitor order date'}
                                                        messageWidth={75}
                                                    />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody key={combinedFilteredPasscodes.length}>
                                            {combinedFilteredPasscodes.map((item, index) => (
                                                <PasscodeItem
                                                    index={index}
                                                    passcode={item}
                                                >
                                                </PasscodeItem>
                                            ))}
                                        </tbody>

                                    </table></>

                                : <>
                                    <div>
                                        <div className={styles.errorPasscodesMessage}> No passcodes found!</div>
                                    </div>
                                </>

                        }

                    </>
                    <br /><br /><br /><br /><br />
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                </div>
            </>
        }
        </>

    );
}

export default ExhibitorPasscodes;